import { useState } from "react";
import HomePage from "./components/Home/HomePage";
import Rules from "./components/Rules/Rules";

function App() {
  const [hideModal, setHideModal] = useState(false)
  return (
    <>
      <HomePage setHideModal={setHideModal}/>
      <Rules  isHiddin={hideModal} closeModal={setHideModal}></Rules>
    </>
  );
}

export default App;
